import React, {FC, useEffect, useRef, useState, useContext} from 'react';
import {IComment, ICommentThread} from "../types/types";
import {get, post} from "../fetchers/fetchers";
import {useParams} from "react-router";

 
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    TextFieldProps
} from "@material-ui/core";
import {Chat} from "@material-ui/icons";
import DialogContentText from "@material-ui/core/DialogContentText";
import Comment from "./comment";
import {  useTask, TasksDispatchContext } from '../stateManagement/context';
import { API_URL } from "../env";
import { getCommentThreads } from '../stateManagement/data';


interface ICommentsProps {
    parent_uuid: number
    type_id:number
}

interface IRouteParams {
    id: string
}


export const get_query = (): {[key: string]: string} => {

    // get query params
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get('state') as string


    let query: {[key: string]: string} = {}
    // get state from local storage

    if (state) {
        query = {"state": state}
    }   

    return query
}

const Comments: FC<ICommentsProps> = ({parent_uuid, type_id}) => {
    let tasks = useTask()
    let dispatch = useContext(TasksDispatchContext)

    const [write_access, setWriteAccess] = useState<boolean>(false);


    const [commentThreadID, setCommentThreadID] = useState<number>(-1);
    const [comments, setComments] = useState<ICommentThread>();

    const [openCreateDialog, setOpenCreateDialog] = useState<boolean>(false);
    const newComment = useRef<TextFieldProps>(null);

    const params = useParams<IRouteParams>()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    },[tasks])

    useEffect(() => {
        if (tasks.loaded) {
            // find the comment thread with the parent_uuid and type_id
            let th = tasks.commentThreads.find((t) => t.parent_uuid === parent_uuid && t.type_id === type_id)
            if (th) {
                setCommentThreadID(th.uuid || -1)
                setComments(th)
            }
        }
    }, [tasks])


    const postCommentThread = async (commentThread: ICommentThread):Promise<ICommentThread> => {
        let c = {... commentThread}
        c.assessment_project_id = parseInt(params.id)

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            c["state_id"] = parseInt(query_params.state)
        }

        const th = await post<ICommentThread>( API_URL + "comments/", c);

        setCommentThreadID(th.uuid ? th.uuid : -1)
        return th
    }

    const postComment = async (comment: IComment) => {
        let c = {... comment}
        c.assessment_project_id = parseInt(params.id)

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            c["state_id"] = parseInt(query_params.state)
        }

        await post<IComment>( API_URL + "comments/" + comment.comment_thread_id, c);


    }

    const createCommentThread = () => {
        postCommentThread({is_active: true, parent_uuid: parent_uuid, type_id:type_id}).then((th) => {

            let comment = newComment.current?.value as string
            postComment({
                comment_thread_id: th.uuid || -1,
                comment: comment

            }).then(() => {
                getCommentThreads(params.id, dispatch)
            })
        })

    }

    const handleClose = () => {
        setOpenCreateDialog(false)
    }
    const handleOpen = () => {
        setOpenCreateDialog(true)
    }

    const handleAddComment = () => {

        if (commentThreadID < 0) {
            createCommentThread()
            handleClose()
            return
        }


        let comment = newComment.current?.value as string
        postComment({
            comment_thread_id: commentThreadID,
            comment: comment

        }).then(() => {
            handleClose()
            getCommentThreads(params.id, dispatch)
        })


    }
    const updateComment = (comment: IComment) => {
        let c = {... comment}
        delete c.id
        delete c.created_at
        delete c.user

        postComment(c).then(() => {
            getCommentThreads(params.id, dispatch)
        })
    }

    return (
        <>
            <Dialog open={openCreateDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Comment</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Add your comment.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Comment"
                        type="text"
                        fullWidth
                        inputRef={newComment}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAddComment} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
            { write_access && 
            <IconButton color="primary" aria-label="upload picture" component="span" style={{
                color: "rgb(239,88,43)",

            }} onClick={() => handleOpen()}>
                <Chat/>
            </IconButton>
            }

            <div>
                {comments?.comments?.map( (c) => (
                    <Comment comment={c} updateComment={updateComment} />
                    )


                )}
            </div>


        </>
    );
};

export default Comments;

